import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { RecurringPushNotificationListUseCaseInterface } from 'domain/usecases/push-notification/recurring-push-notification-list';

export class RemoteRecurringPushNotificationList
  implements RecurringPushNotificationListUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(): Promise<RecurringPushNotificationListUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
